import type { FieldErrors, FieldValues, Resolver, ResolverResult } from 'react-hook-form'
import type { ZodType } from 'zod'

export function zodResolver<T extends FieldValues>(schema: ZodType<T>): Resolver<T> {
  return (values) => {
    const result = schema.safeParse(values)

    if (result.success) {
      return { values: result.data, errors: {} } as ResolverResult<T>
    }

    const errors: Record<string, { type: string; message: string }> = {}
    for (const issue of result.error.issues) {
      const key = issue.path.join('.') || 'root'
      if (!errors[key]) {
        errors[key] = { type: 'validation', message: issue.message }
      }
    }

    return { values: {}, errors: errors as unknown as FieldErrors<T> } as ResolverResult<T>
  }
}